import { useMemo } from 'react';
import { useIsElectron } from '@/context/ElectronContext';
import { getVisibleActions } from '@/common/types/itemActions';
import { useProjectDetails } from '../context/ProjectDetailsContext';
import { useRevealInFileExplorer } from './useRevealInFileExplorer';

export function useProjectHeaderActions() {
  const { projectDirPath, latestVersionFiles } = useProjectDetails();
  const isElectron = useIsElectron();
  const { revealInExplorer } = useRevealInFileExplorer();

  return useMemo(
    () =>
      getVisibleActions([
        {
          id: 'open-project-folder',
          label: 'Open project folder',
          visible:
            isElectron && !!projectDirPath && latestVersionFiles.length > 0,
          onClick: () =>
            revealInExplorer(
              { path: projectDirPath!, kind: 'folder' },
              'Opening project folder...'
            ),
        },
      ]),
    [isElectron, projectDirPath, latestVersionFiles.length, revealInExplorer]
  );
}
